"use client";

import { cn } from "@/lib/utils";
import { Column, Table } from "@tanstack/react-table";
import { ArrowDown, ArrowUp } from "lucide-react";

export default function Sort<T>(props: {
  column: Column<T, any>;
  table: Table<T>;
}) {
  const sorted = props.column.getIsSorted();

  return (
    <div className="flex">
      {{
        asc: <ArrowUp size={18} className="text-primary" />,
        desc: <ArrowDown size={18} className="text-primary" />,
      }[sorted as string] ?? null}
    </div>
  );
}
